// Module
var code = " <p class=\"item-amount\"> <span ng-bind=\"$ctrl.raffleItem.tickets_remaining || 0\"></span> </p> ";
// Exports
export default code;